export default __webpack_public_path__ + "static/media/d58d07cff1e8ff3fe9a2cc33213a8aa9.svg";